import React from 'react'
import { Link } from 'react-router-dom'
import styles from './MentalHealthButton.module.css'
import Button from '@material-ui/core/Button';


function MentalHealthButton() {
    return (
        <Link to='/mental-health-page' className={styles.link}>
            <div className={styles.component}>
                <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    className={styles.button}
                    >
                        Mental Health and why is it important?
                </Button>
            </div>
        </Link>
    )
}

export default MentalHealthButton
